import { Client } from '@/utilities/api/Client';
import { QueryUtil } from '@/utilities/Query';
import { PointsAuditEndpoint } from '@api/endpoints';

/** Internal-only. Reads are not behind the feature flag; `revert` is the only write. */
export class PointsAuditApi {
  static listForFarmer (
    farmerId: string,
    query: PointsAuditEndpoint.ListForFarmer.QueryParams = {},
  ): Promise<PointsAuditEndpoint.ListForFarmer.Response> {
    return Client(`admin/farmer/${farmerId}/points-audit?${QueryUtil.stringify(query)}`);
  }

  static list (
    query: PointsAuditEndpoint.List.QueryParams = {},
  ): Promise<PointsAuditEndpoint.List.Response> {
    return Client(`admin/points-audit?${QueryUtil.stringify(query)}`);
  }

  static listForRetailer (
    retailerId: string,
    query: PointsAuditEndpoint.ListForRetailer.QueryParams = {},
  ): Promise<PointsAuditEndpoint.ListForRetailer.Response> {
    return Client(`admin/retailer/${retailerId}/points-audit?${QueryUtil.stringify(query)}`);
  }

  static farmerLedger (
    processId: string,
    farmerId: string,
    query: PointsAuditEndpoint.FarmerLedger.QueryParams = {},
  ): Promise<PointsAuditEndpoint.FarmerLedger.Response> {
    return Client(
      `admin/points-audit/process/${processId}/farmer/${farmerId}/ledger`
      + `?${QueryUtil.stringify(query)}`,
    );
  }

  static summary (
    retailerId: string,
    query: PointsAuditEndpoint.Summary.QueryParams = {},
  ): Promise<PointsAuditEndpoint.Summary.Response> {
    return Client(
      `admin/retailer/${retailerId}/points-audit/summary?${QueryUtil.stringify(query)}`,
    );
  }

  static listProcesses (
    retailerId: string,
    query: PointsAuditEndpoint.ListProcesses.QueryParams = {},
  ): Promise<PointsAuditEndpoint.ListProcesses.Response> {
    return Client(
      `admin/retailer/${retailerId}/points-audit/processes?${QueryUtil.stringify(query)}`,
    );
  }

  static getProcess (processId: string): Promise<PointsAuditEndpoint.GetProcess.Response> {
    return Client(`admin/points-audit/process/${processId}`);
  }

  /** Writes nothing. */
  static revertPreview (
    processId: string,
  ): Promise<PointsAuditEndpoint.RevertPreview.Response> {
    return Client(`admin/points-audit/process/${processId}/revert-preview`);
  }

  static revert (
    processId: string,
    body: PointsAuditEndpoint.Revert.Request,
  ): Promise<PointsAuditEndpoint.Revert.Response> {
    return Client(`admin/points-audit/process/${processId}/revert`, { body, method: 'POST' });
  }
}
